import { toFlatField } from '../oasis-types';
import { bloodPressureValidation } from '../shared/blood-pressure-validation';
import { baseTemperature, baseTemperatureRefined, baseO2, baseO2Refined, baseRespiration, baseRespirationRefined, basePulse, basePulseRefined, baseBloodSugar, baseBloodSugarRefined, baseBloodPressure, } from '../shared/vitals';
export { baseTemperature, baseTemperatureRefined, baseO2, baseO2Refined, baseRespiration, baseRespirationRefined, basePulse, basePulseRefined, baseBloodSugar, baseBloodSugarRefined, baseBloodPressure, };
export const baseBloodPressureRefined = bloodPressureValidation({
    checkboxLabel: 'Not Captured',
});
export { basePain, basePainRefined } from '../shared/pain';
export const VitalsVersioned = {
    temperature: { e1: { alias: 'temperature', timepoint: ['soc', 'roc', 'rct', 'dsch', 'tr'] } },
    o2: { e1: { alias: 'o2', timepoint: ['soc', 'roc', 'tr', 'trd', 'rct', 'dsch'] } },
    respiration: { e1: { alias: 'respiration', timepoint: ['soc', 'roc', 'tr', 'trd', 'rct', 'dsch'] } },
    pulse: { e1: { alias: 'pulse', timepoint: ['soc', 'roc', 'tr', 'trd', 'rct', 'dsch'] } },
    bloodSugar: { e1: { alias: 'bloodSugar', timepoint: ['soc', 'roc', 'tr', 'trd', 'rct', 'dsch'] } },
    bloodPressure: { e1: { alias: 'bloodPressure', timepoint: ['soc', 'roc', 'rct', 'dsch', 'tr'] } },
    pain: { e1: { alias: 'pain', timepoint: ['soc', 'roc', 'tr', 'trd', 'rct', 'dsch'] } },
};
export const Vitals = toFlatField(VitalsVersioned);
